export const SERVICE_FLOW_STORAGE_KEYS = Object.freeze({
  ITEMS: 'serviceFlowItems',
  NO_DATA_WARNING: 'serviceFlowNoDataWarning',
});

export function readSessionStorageJson(key, fallback = null) {
  try {
    const rawValue = sessionStorage.getItem(key);
    return rawValue === null ? fallback : JSON.parse(rawValue);
  } catch {
    return fallback;
  }
}

export function writeSessionStorageJson(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    return false;
  }

  return true;
}

export function readSessionStorageFlag(key) {
  return readSessionStorageJson(key, false) === true;
}

export function writeSessionStorageFlag(key, value) {
  return writeSessionStorageJson(key, Boolean(value));
}

export function removeSessionStorageValue(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    return false;
  }

  return true;
}
